import { c as _c } from "react/compiler-runtime";
import type { IconPropsWithoutVariant } from './Icon';
import { IconWithoutVariants } from './Icon';
import type { IconVariantMap } from './icons-traffic';
import SystemIcons from './icons-traffic-sprite.svg';
type Props<IconName extends keyof IconVariantMap> = Omit<IconPropsWithoutVariant<IconVariantMap, IconName>, 'spriteSrc'>;
export function IconTraffic(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWithoutVariants spriteSrc={SystemIcons.src} role="img" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}